import { defineMessages } from "react-intl";

export const scope = "activity";

export default defineMessages({
  filterText: {
    id: `${scope}.filter.text`,
    defaultMessage: "Filter",
  },
  allText: {
    id: `${scope}.all.text`,
    defaultMessage: "All",
  },
  communicationText: {
    id: `${scope}.communication.text`,
    defaultMessage: "Communication",
  },
  callsText: {
    id: `${scope}.calls.text`,
    defaultMessage: "Calls",
  },
  smsText: {
    id: `${scope}.sms.text`,
    defaultMessage: "SMS",
  },
  emailsText: {
    id: `${scope}.emails.text`,
    defaultMessage: "Emails",
  },
  statusText: {
    id: `${scope}.status.text`,
    defaultMessage: "Status Changes",
  },
  appointmentsText: {
    id: `${scope}.appointments.text`,
    defaultMessage: "Appointments",
  },
  activityText: {
    id: `${scope}.activity.text`,
    defaultMessage: "Contact Activity",
  },
  addsText: {
    id: `${scope}.adds.text`,
    defaultMessage: "Adds Activity",
  },
  emailTrackingText: {
    id: `${scope}.email.tracking.text`,
    defaultMessage: "Email Tracking",
  },
  formSubmissionText: {
    id: `${scope}.form.submission.text`,
    defaultMessage: "Form Submission",
  },
  marketingEmailsText: {
    id: `${scope}.marketing.emails.text`,
    defaultMessage: "Marketing Emails",
  },
  pageViewsText: {
    id: `${scope}.page.views.text`,
    defaultMessage: "Page Views",
  },
  phoneNumberText: {
    id: `${scope}.phone.number.text`,
    defaultMessage: "Phone Number: ",
  },
  emailText: {
    id: `${scope}.email.text`,
    defaultMessage: "Email: ",
  },
  sourceText: {
    id: `${scope}.source.text`,
    defaultMessage: "Source: ",
  },
  messageText: {
    id: `${scope}.message.text`,
    defaultMessage: "Message: ",
  },
  subjectText: {
    id: `${scope}.subject.text`,
    defaultMessage: "Subject: ",
  },
  awardCompleted: {
    id: `${scope}.award.completed.text`,
    defaultMessage: "Award completed",
  },
  awardRedeemed: {
    id: `${scope}.award.redeemed.text`,
    defaultMessage: "Award redeemed",
  },
  awardEdited: {
    id: `${scope}.award.edited.text`,
    defaultMessage: "Award edited",
  },
  awardExpired: {
    id: `${scope}.award.expired.text`,
    defaultMessage: "Award expired",
  },
  completedStatus: {
    id: `${scope}.completed.status`,
    defaultMessage: "Completed",
  },
  uncompletedStatus: {
    id: `${scope}.uncompleted.status`,
    defaultMessage: "Incomplete",
  },
  redeemedStatus: {
    id: `${scope}.redeemed.status`,
    defaultMessage: "Redeemed",
  },
  invoiceStatus: {
    id: `${scope}.invoiceStatus.text`,
    defaultMessage: "Status: {status} ",
  },
  invoiceDueDate: {
    id: `${scope}.invoiceDueDate.date`,
    defaultMessage: "Due Date: {date} ",
  },
  collectedForAward: {
    id: `${scope}.invoiceCollectedFor.award`,
    defaultMessage:
      "Amount from this payment will be added to award: {awardTitle} ",
  },
  invoiceUrl: {
    id: `${scope}.invoiceURL.url`,
    defaultMessage: "Invoice url: ",
  },
  inoviceLink: {
    id: `${scope}.invoiceLink.link`,
    defaultMessage: "link",
  },
  totalAmount: {
    id: `${scope}.totalAmount.invoice`,
    defaultMessage: "Total:",
  },
  refundAmount: {
    id: `${scope}.refundAmount.invoice`,
    defaultMessage: "Refund:",
  },
  subtotal: {
    id: `${scope}.subTotal.invoice`,
    defaultMessage: "Subtotal: ",
  },
  discount: {
    id: `${scope}.discount.invoice`,
    defaultMessage: "Discount:",
  },
  tax: {
    id: `${scope}.tax.invoice`,
    defaultMessage: "Tax:",
  },
  defaultAwardCompleted: {
    id: `${scope}.default.award.comeplted`,
    defaultMessage: "Default Award Completed",
  },
  defaultAwardRedeemed: {
    id: `${scope}.default.award.redeemed`,
    defaultMessage: "Default Award Redeemed",
  },
  campaignsText: {
    id: `${scope}.campaigns.text`,
    defaultMessage: "Campaigns",
  },
  transactionsText: {
    id: `${scope}.transactions.text`,
    defaultMessage: "Transactions",
  },
  invoiceText: {
    id: `${scope}.invoice.text`,
    defaultMessage: "Invoice",
  },
  completedLabel: {
    id: `${scope}.completed.label`,
    defaultMessage: "Completed",
  },
  editedLabel: {
    id: `${scope}.edited.label`,
    defaultMessage: "Edited",
  },
  createdLabel: {
    id: `${scope}.created.label`,
    defaultMessage: "Created",
  },
  packages: {
    id: `${scope}.packages`,
    defaultMessage: "Packages",
  },
  tnxTitle: {
    id: `${scope}.tnx.title`,
    defaultMessage: "Transaction",
  },
  apptTitle: {
    id: `${scope}.appt.title`,
    defaultMessage: "Appointment",
  },
  invoiceTitle: {
    id: `${scope}.invoice.title`,
    defaultMessage: "Details",
  },
  rescheduledByText: {
    id: `${scope}.rescheduledByText.text`,
    defaultMessage: "Appointment is rescheduled by ",
  },
  fromText: {
    id: `${scope}.fromText.text`,
    defaultMessage: "From: ",
  },
  toText: {
    id: `${scope}.toText.text`,
    defaultMessage: "To: ",
  },
  membershipText: {
    id: `${scope}.membership.text`,
    defaultMessage: "Membership",
  },
  expiredLabel: {
    id: `${scope}.expired.label`,
    defaultMessage: "Expired",
  },
  downpaymentTxnTitie: {
    id: `${scope}.downpaymentTxnTitie.text`,
    defaultMessage: "Cupon: {title} ",
  },
  manualPayment: {
    id: `${scope}.manual.payment`,
    defaultMessage: "Manual or Incoming payment",
  },
  cancellationFee: {
    id: `${scope}.cancellationFee.payment`,
    defaultMessage: "Cancellation fee",
  },
  appointmentFee: {
    id: `${scope}.appointmentFee.payment`,
    defaultMessage: "Appointment fee",
  },
  cash: {
    id: `${scope}.cash.invoice`,
    defaultMessage: "Cash:",
  },
  card: {
    id: `${scope}.card.invoice`,
    defaultMessage: "Card:",
  },
  loyaltyText: {
    id: `${scope}.loyalty.text`,
    defaultMessage: "Loyalty",
  },
  loyaltyPointsText: {
    id: `${scope}.loyalty.points.text`,
    defaultMessage: "Loyalty Points",
  },
  loyaltyLevelText: {
    id: `${scope}.loyalty.level.text`,
    defaultMessage: "Loyalty Level",
  },
  loyaltyItemText: {
    id: `${scope}.loyalty.item.text`,
    defaultMessage: "Loyalty Awards",
  },
  callTranscriptionModalTitle: {
    id: `${scope}.callTranscriptionModal.title`,
    defaultMessage: "Call Transcription",
  },
  filters: {
    id: `${scope}.filters.text`,
    defaultMessage: "Filters",
  },
  clear: {
    id: `${scope}.clear.text`,
    defaultMessage: "Clear",
  },
  clearAll: {
    id: `${scope}.clear.all.text`,
    defaultMessage: "Clear all",
  },
  close: {
    id: `${scope}.close.text`,
    defaultMessage: "Close",
  },
  apply: {
    id: `${scope}.apply.text`,
    defaultMessage: "Apply",
  },
  taxAmount: {
    id: `${scope}.tax.amount`,
    defaultMessage: "Tax",
  },
  tipAmount: {
    id: `${scope}.tip.amount`,
    defaultMessage: "Tip",
  },
  invoiceRefundedActivityText: {
    id: `${scope}.invoiceRefunded.activityText`,
    defaultMessage: "Invoice refunded",
  },
  originalInvoiceTitle: {
    id: `${scope}.originalInvoice.title`,
    defaultMessage: "Original Invoice",
  },
  refundDetailsTitle: {
    id: `${scope}.refundDetails.title`,
    defaultMessage: "Refund Details",
  },
  refundedToCard: {
    id: `${scope}.refundedToCard.text`,
    defaultMessage: "Card refund:",
  },
  refundedToCash: {
    id: `${scope}.refundedToCash.text`,
    defaultMessage: "Cash refund:",
  },
  refundNote: {
    id: `${scope}.refundNote.text`,
    defaultMessage: "Note:",
  },
  refundedBy: {
    id: `${scope}.refundedBy.text`,
    defaultMessage: "Refunded by: {name}",
  },
  refundBtn: {
    id: `${scope}.refund.btn`,
    defaultMessage: "Refund",
  },
  moreRefundBtn: {
    id: `${scope}.moreRefund.btn`,
    defaultMessage: "More Refund",
  },
  refundModalTitle: {
    id: `${scope}.refundModal.title`,
    defaultMessage: "Refund Invoice",
  },
  refundItemName: {
    id: `${scope}.refundItem.name`,
    defaultMessage: "Item",
  },
  refundItemMaxAmount: {
    id: `${scope}.refundItem.maxAmount`,
    defaultMessage: "Max: {amount}",
  },
  refundAmountLabel: {
    id: `${scope}.refundAmount.label`,
    defaultMessage: "Refund Amount",
  },
  refundNoteLabel: {
    id: `${scope}.refundNote.label`,
    defaultMessage: "Note (optional)",
  },
  refundSubmitBtn: {
    id: `${scope}.refundSubmit.btn`,
    defaultMessage: "Submit Refund",
  },
  refundFullAmountLabel: {
    id: `${scope}.refundFullAmount.label`,
    defaultMessage: "Full refund amount",
  },
  refundGiftCardFullOnly: {
    id: `${scope}.refundGiftCardFullOnly.msg`,
    defaultMessage:
      "This invoice includes a gift card — partial refunds are not available. Only a full invoice refund is possible.",
  },
  refundNotePlaceholder: {
    id: `${scope}.refundNote.placeholder`,
    defaultMessage: "Reason for refund...",
  },
  refundInvoiceTotal: {
    id: `${scope}.refundInvoice.total`,
    defaultMessage: "Invoice Total",
  },
  refundAlreadyRefunded: {
    id: `${scope}.refundAlready.refunded`,
    defaultMessage: "Already Refunded",
  },
  refundMaxRefundable: {
    id: `${scope}.refundMax.refundable`,
    defaultMessage: "Max Refundable",
  },
  refundMaxCard: {
    id: `${scope}.refundMax.card`,
    defaultMessage: "Max to Card",
  },
  refundPreviousRefunds: {
    id: `${scope}.refundPrevious.refunds`,
    defaultMessage: "Previous refunds ({count})",
  },
  refundSelectItems: {
    id: `${scope}.refundSelect.items`,
    defaultMessage: "Select items to refund",
  },
  refundImpactPreview: {
    id: `${scope}.refundImpact.preview`,
    defaultMessage: "Refund impact on product sales",
  },
  refundEmployeeTipImpact: {
    id: `${scope}.refundEmployeeTip.impact`,
    defaultMessage: "Employee tip deductions",
  },
  refundColGross: {
    id: `${scope}.refundCol.gross`,
    defaultMessage: "Gross",
  },
  refundColRefund: {
    id: `${scope}.refundCol.refund`,
    defaultMessage: "Refund",
  },
  refundColTax: {
    id: `${scope}.refundCol.tax`,
    defaultMessage: "Tax",
  },
  refundColTip: {
    id: `${scope}.refundCol.tip`,
    defaultMessage: "Tip",
  },
  refundColNewGross: {
    id: `${scope}.refundCol.newGross`,
    defaultMessage: "New Gross",
  },
  refundColEmployee: {
    id: `${scope}.refundCol.employee`,
    defaultMessage: "Employee",
  },
  refundColTipDeduction: {
    id: `${scope}.refundCol.tipDeduction`,
    defaultMessage: "Tip Deduction",
  },
  refundTotalRefund: {
    id: `${scope}.refundTotal.refund`,
    defaultMessage: "Total Refund",
  },
  refundToCard: {
    id: `${scope}.refundTo.card`,
    defaultMessage: "Refund to card",
  },
  refundToCash: {
    id: `${scope}.refundTo.cash`,
    defaultMessage: "Refund as cash",
  },
  refundPreviouslyRefunded: {
    id: `${scope}.refundPreviously.refunded`,
    defaultMessage: "Previously refunded",
  },
  refundTotalAlreadyRefunded: {
    id: `${scope}.refundTotalAlready.refunded`,
    defaultMessage: "Total refunded on item",
  },
  refundAvailableToRefund: {
    id: `${scope}.refundAvailable.toRefund`,
    defaultMessage: "Available to refund",
  },
  refundBreakdownNet: {
    id: `${scope}.refundBreakdown.net`,
    defaultMessage: "Product sales",
  },
  refundAvailableAfter: {
    id: `${scope}.refundAvailable.after`,
    defaultMessage: "Left after",
  },
  refundCashConfirmTitle: {
    id: `${scope}.refundCashConfirm.title`,
    defaultMessage: "Cash refund required",
  },
  refundCashConfirmContent: {
    id: `${scope}.refundCashConfirm.content`,
    defaultMessage:
      "This refund includes {amount} that must be returned as cash. Please make sure to hand this amount to the customer.",
  },
  refundArn: {
    id: `${scope}.refund.arn`,
    defaultMessage: "ARN: {arn}",
  },
  refundArnPending: {
    id: `${scope}.refund.arnPending`,
    defaultMessage: "ARN: Pending (available in 1-3 business days)",
  },
  refundSuccessMsg: {
    id: `${scope}.refund.success.msg`,
    defaultMessage: "Refund submitted successfully",
  },
});
